import React from 'react'
import { PrismicRichText } from '@prismicio/react'

// Components
import ChevronDown from './svg/chevronDown'

const Accordion = ({ slice }) => {
  return (
    <section className='component-faq mx-auto max-w-screen-xl p-6'>
      <div className='prose prose-lg mx-auto max-w-none'>
        {slice.primary.faq_title && <h2>{slice.primary.faq_title}</h2>}
        {slice.primary.faq_text && <PrismicRichText field={slice.primary.faq_text.richText} />}
        <div className='mx-auto mt-3'>
          {slice.items.map((accordion, index) => {
            return (
              <details className='mb-3 transform overflow-hidden rounded bg-white shadow-sm transition-all' key={`accordion-${index}`}>
                <summary className='m-0 flex w-full cursor-pointer items-center justify-between bg-white p-4 text-left font-medium text-primary outline-none hover:text-primaryHover'>
                  {accordion.question}
                  <span className='text-orange-500'>
                    <ChevronDown />
                  </span>
                </summary>
                <div className='prose prose-lg max-w-full border-t p-4'>
                  <PrismicRichText field={accordion.answer.richText} />
                </div>
              </details>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Accordion
